export const FormLabel = 'atlantis-form-label';
export const FormInput = 'atlantis-form-input';
export const FormCheckBox = 'atlantis-form-checkbox';
export const FormFileUpload = 'atlantis-form-file-upload';
export const FormTextArea = 'atlantis-form-text-area';
export const FormTextBlock = 'atlantis-form-text-block';
export const FormValidation = 'atlantis-form-validation';
export const FormInputMaxLengthCounter =
   'atlantis-form-input-max-length-counter';
